import React, { Component } from 'react'
import ErrorPage from 'common/components/ErrorPage'

class ErrorBoundary extends Component {
  state = {
    hasError: false,
    error: null,
    info: null
  }

  componentDidCatch (error, info) {
    this.setState({ hasError: true, error, info })
  }

  render () {
    if (this.state.hasError) {
      return <ErrorPage />
    }
    return this.props.children
  }
}

export default ErrorBoundary
